/**
 * Hoppscotch ENVIRONMENT export → ImportedEnv[].
 *
 * `{ v: 2, name, variables: [{ key, initialValue, currentValue, secret }] }`
 * (v0/v1: `{ key, value }`), one object or an array. A secret's value is not
 * in the export (Hoppscotch blanks it), so it lands as `secret: true` with an
 * empty value and one warning says how many to fill in (O7) — there is no
 * imported value to hide, which is why this differs from the Postman rule.
 * `<<x>>` references inside values become `{{x}}`.
 */
import { convertHoppVars } from './hoppVars';

const str = (v) => (v == null ? '' : String(v));

export function parseHoppscotchEnv(data, fallbackName = '') {
  const list = (Array.isArray(data) ? data : [data]).filter((e) => e && typeof e === 'object');
  return list.map((env, i) => ({
    name: str(env.name).trim() || (list.length === 1 && fallbackName) || `Environment ${i + 1}`,
    variables: (Array.isArray(env.variables) ? env.variables : [])
      .filter((v) => v && typeof v.key === 'string' && v.key !== '')
      .map((v) => ({
        key: v.key,
        value: v.secret === true ? '' : convertHoppVars(str(v.initialValue || v.currentValue || v.value || '')),
        enabled: true,
        secret: v.secret === true,
      })),
  }));
}
